export const getMasavExports = (state) => state.masavExports.masavExports;
export const getMasavExportsCount = (state) => state.masavExports.masavExportsCount;
export const getCurrentExport = (state) => state.masavExports.currentExport;
export const getLoading = (state) => state.masavExports.loading;
export const getError = (state) => state.masavExports.error;
export const getIsSubmitting = (state) => state.masavExports.isSubmitting;
export const getUploadSuccess = (state) => state.masavExports.uploadSuccess;

// Aliases for consistency
export const selectMasavExportsLoading = getLoading;
export const selectCurrentMasavExport = getCurrentExport;

